import gql from 'graphql-tag';

export const UPSERT_VENDOR_OPPORTUNITY_REVENUE_FROM_CALCULATIONS = gql`
  mutation UpsertVendorOpportunityRevenueFromCalculations(
    $input: UpsertVendorOpportunityRevenueFromCalculationsInput!
  ) {
    result: upsertVendorOpportunityRevenueFromCalculations(input: $input) {
      id
    }
  }
`;
